import { render } from "./CollectionDetailedSearchMagazine.vue?vue&type=template&id=4a05ca3e&scoped=true&ts=true"
import script from "./CollectionDetailedSearchMagazine.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchMagazine.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchMagazine.vue?vue&type=style&index=0&id=4a05ca3e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a05ca3e"]])

export default __exports__